import React from 'react';

import { Button, LbInput, Surface, TitleWithDescription } from '@infoods/lifebase-ui';
import { useForm } from 'react-hook-form';

import classes from './PromoCodeCard.module.scss';
import { validatePromoCode } from '../../utils/validatePromoCode/validatePromoCode';

type PromoCodeCardProps = {
  onApplyPromoCode: (promoCode: string) => void;
};

type PromoCodeFormValues = {
  promoCode: string;
};

const PromoCodeCard = ({ onApplyPromoCode }: PromoCodeCardProps) => {
  const { control, handleSubmit } = useForm<PromoCodeFormValues>();

  const onSubmit = handleSubmit((data) => {
    onApplyPromoCode(data.promoCode);
  });

  return (
    <Surface className={classes.container}>
      <TitleWithDescription
        title="Have a promo code?"
        description="Please enter the promo code to receive a discount."
        descriptionColor="neutral-600"
      />
      <form onSubmit={onSubmit} className={classes.form}>
        <LbInput
          control={control}
          name="promoCode"
          label="Promo code"
          variant="outlined"
          size="small"
          placeholder="Enter promo code"
          rules={{
            validate: { validatePromoCode },
          }}
        />
        <Button type="submit" variant="contained" color="primary" size="small">
          Apply
        </Button>
      </form>
    </Surface>
  );
};

export { PromoCodeCard, type PromoCodeCardProps };
